import { ApiVariantKey } from '@upright/common/model/output/scores/model-entity-data/api-types';
import { ModelEntityWithScores } from '@upright/common/model/output/scores/model-entity-data/types';
import { useCompanyScores } from '@upright/ui/views/model-entity-views/company-view/use-company-scores';
import { compact, flatten, uniqBy } from 'lodash';

/** `variantKey` picks the result to name products from; by default, the one the company page shows. */
export function useCompanyProductNames(companyId: string, variantKey?: ApiVariantKey) {
  const companyScores = useCompanyScores(companyId, { options: variantKey });
  const productNames = scoreDataToProductNames(companyScores.data);
  return productNames;
}

function scoreDataToProductNames(data?: ModelEntityWithScores) {
  if (!data) {
    return;
  }
  return uniqBy(flatten(compact(data.modelResults.map(result => result.productNames))), ref => ref.id);
}
